const config = {
    apiUrl: "http://localhost:3001",
    uiUrl : "http://localhost:3001",
    featureFlag: true
  };

  export default config;